import * as React from 'react';
import TestCardsList from './test_cards_list';
import { shallow, ShallowWrapper } from 'enzyme';

let wrapped: ShallowWrapper;

const standardTests = {
  data: [
    {
      attributes: {
        id: 1,
        name: 'Test',
        duration: 15,
        language: ['Ruby', 'React'],
        experience_levels: ['1year', 'Junior'],
      },
    },
  ],
};

describe('Test Cards List component', () => {
  beforeEach(() => {
    wrapped = shallow(
      <TestCardsList
        standardTests={standardTests.data}
        handleTestIdSelect={jest.fn()}
        selectedTest={2}
      />
    );
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});
